
import React from 'react';

import { TablePagination } from '@newsela/angelou';
import PropTypes from 'prop-types';

const pageSizeOptions = [
  {
    value: 10,
    label: '10',
  },
  {
    value: 20,
    label: '20',
  },
  {
    value: 50,
    label: '50',
  },
  {
    value: 100,
    label: '100',
  },
];

const Pagination = ({ currentPage, total, onPageChange, pageSize, onPageSizeChange }) => {
  const canPreviousPage = currentPage > 0;
  const lastPageIndex = Math.ceil(total / pageSize) - 1;
  const canNextPage = currentPage < lastPageIndex;
  const handlePrev = () => {
    if (canPreviousPage) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (canNextPage) {
      onPageChange(currentPage + 1);
    }
  };

  const handleFirstPage = () => {
    if (canPreviousPage) {
      onPageChange(0);
    }
  };

  return (
    <TablePagination
      pageSize={pageSize}
      pageSizeOptions={pageSizeOptions}
      pageIndex={currentPage}
      totalItems={total}
      canNextPage={canNextPage}
      canPreviousPage={canPreviousPage}
      nextPage={handleNext}
      gotoPage={handleFirstPage}
      previousPage={handlePrev}
      onPageSizeChange={onPageSizeChange}
    />
  );
};

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  total: PropTypes.number,
  pageSize: PropTypes.number,
  onPageChange: PropTypes.func.isRequired,
  onPageSizeChange: PropTypes.func.isRequired,
};

export default Pagination;
